import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function StickyBookingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
    >
      {/* Book Tour */}
      <Link
        to="/location#contact"
        className="flex items-center gap-3 bg-rdr-charcoal text-white px-5 py-3 font-sans text-xs font-medium tracking-[0.15em] uppercase whitespace-nowrap hover:bg-rdr-warm transition-colors duration-300 cursor-pointer"
        aria-label="Book a tour at Red Door Ranch"
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-calendar-line text-sm" />
        </div>
        Book a Tour
      </Link>

      {/* Click to Call */}
      <a
        href="tel:+18175048501"
        className="flex items-center gap-3 bg-rdr-gold text-white px-5 py-3 font-sans text-xs font-medium tracking-[0.15em] uppercase whitespace-nowrap hover:bg-rdr-gold-light transition-colors duration-300 cursor-pointer"
        aria-label="Call Red Door Ranch"
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-phone-fill text-sm" />
        </div>
        (817) 504-8501
      </a>
    </div>
  );
}
